import { DomainProjectFilter } from '@/common/utils/formatDomainFilters';
import { castArray, union, uniq } from 'lodash-es';

export function formatSort(sort: Sort = {}, keyMap: Record<string, string>): string | undefined {
  return (sort?.key && keyMap[sort.key]) && `${keyMap[sort.key]}:${sort.ascending ? 'asc' : 'desc'}`;
}

export function formatSearchString(searchString = '', strict = false): string | undefined {
  const queryString = searchString.trim();
  if (queryString) {
    return strict ? queryString : `contains:${queryString}`;
  }
  return undefined;
}

export function formatArrayIn<T>(items: Array<T> = []): string | undefined {
  return Array.isArray(items) && items.length ? `in:${uniq(items).join(',')}` : undefined;
}

export function formatArrayAny<T>(items: Array<T> = [], defaultItems?: T | Array<T>): string | undefined {
  if (!Array.isArray(items)) {
    return undefined;
  }
  let itemsList: Array<T | 'None'> = defaultItems
    ? union(items, castArray(defaultItems))
    : items;

  itemsList = uniq(itemsList)
    .map(key => key === null ? 'None' : key)
    .filter(Boolean);

  return itemsList.length ? `any:${itemsList.join(',')}` : undefined;
}

export function formatArrayByKeyMap(key: string, keyMap: Record<string, Array<any>> = {}): string | undefined {
  if (!key || !keyMap[key]) {
    return undefined;
  }

  const values = keyMap[key];
  if (values.length === 1) {
    return values[0];
  }
  return formatArrayIn(values);
}

export function formatProjectIdFilters(items: Array<DomainProjectFilter['value']> = []) {
  const projects = items?.filter((it) => !it?.startsWith('domain:'));

  return projects.length ? `in:${projects.join(',')}` : undefined;
}

export function formatDomainIdFilters(items: Array<DomainProjectFilter['value']> = []) {
  const domains = items?.filter((it) => it.startsWith('domain:'))
    .map(it => it.replace('domain:', ''));

  if (!domains.length) {
    return undefined;
  }

  return domains.length === 1 ? domains[0] : `in:${domains.join(',')}`;
}
